import React, { FC } from "react";
import styled from "styled-components";
import { Tag, Spin } from "antd";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import type { RootState } from "@redux/rootReducer";
import AnchorToChart from "../AnchorToChart";

const Wrapper = styled.div`
  padding: 25px;
  border: 1px solid #f0f0f0;
  margin-right: 20px;
  margin-bottom: 20px;
  min-width: 362px;
  border-radius: 2px;
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
`;
const HeaderTitle = styled.div`
  padding: 7px 16px;
  border: 1px solid #f0f0f0;
  background: #f2f4f5;
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.colorNeutral600};
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  grid-row-gap: 25px;
`;
const Section = styled.div`
  display: flex;
  flex-direction: column;
`;
const BottomSection = styled(Section)`
  grid-row-start: 2;
`;
const SectionTitle = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 0, 0, 0.45);
  margin-bottom: 10px;
`;
const SectionContent = styled.div`
  display: flex;
  align-items: center;
  font-size: 24px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colorNeutral600};
`;
const StyledTag = styled(Tag)`
  padding: 1px 6px;
  margin-left: 8px;
`;

const VipStatusCard: FC = () => {
  const isFetchingVipMemberStatusDashboard = useSelector(
    (state: RootState) => state.dashboard.isFetchingVipMemberStatusDashboard,
  );
  const vipMemberStatusDashboard = useSelector((state: RootState) => state.dashboard.vipMemberStatusDashboard);
  const { currentData, diff } = vipMemberStatusDashboard;
  const { cancelCount = 0, firstBuyCount = 0, renewCount = 0 } = currentData || {};
  const { cancelCountDiff = 0, firstBuyCountDiff = 0, renewCountDiff = 0 } = diff || {};

  const cancelCountTagColor = cancelCountDiff < 0 ? "error" : "success";
  const cancelCountTagIcon = cancelCountDiff < 0 ? <CaretDownOutlined /> : <CaretUpOutlined />;
  const cancelCountChangePercentage = Math.round(cancelCountDiff * 1000) / 10; // 百分比取小數點第一位

  const firstBuyCountTagColor = firstBuyCountDiff < 0 ? "error" : "success";
  const firstBuyCountTagIcon = firstBuyCountDiff < 0 ? <CaretDownOutlined /> : <CaretUpOutlined />;
  const firstBuyCountChangePercentage = Math.round(firstBuyCountDiff * 1000) / 10; // 百分比取小數點第一位

  const renewCountTagColor = renewCountDiff < 0 ? "error" : "success";
  const renewCountTagIcon = renewCountDiff < 0 ? <CaretDownOutlined /> : <CaretUpOutlined />;
  const renewCountChangePercentage = Math.round(renewCountDiff * 1000) / 10;

  return (
    <Spin spinning={isFetchingVipMemberStatusDashboard}>
      <Wrapper>
        <Header>
          <HeaderTitle>會員狀態</HeaderTitle>
          <AnchorToChart href="/dashboard/vip-status" />
        </Header>
        <Grid>
          <Section>
            <SectionTitle>取消黑卡會員人數</SectionTitle>
            <SectionContent>
              {cancelCount}
              <StyledTag color={cancelCountTagColor} icon={cancelCountTagIcon}>
                {`${cancelCountChangePercentage}%`}
              </StyledTag>
            </SectionContent>
          </Section>
          <BottomSection>
            <SectionTitle>新增黑卡會員人數</SectionTitle>
            <SectionContent>
              {firstBuyCount}
              <StyledTag color={firstBuyCountTagColor} icon={firstBuyCountTagIcon}>
                {`${firstBuyCountChangePercentage}%`}
              </StyledTag>
            </SectionContent>
          </BottomSection>
          <BottomSection>
            <SectionTitle>舊客續約人數</SectionTitle>
            <SectionContent>
              {renewCount}
              <StyledTag color={renewCountTagColor} icon={renewCountTagIcon}>
                {`${renewCountChangePercentage}%`}
              </StyledTag>
            </SectionContent>
          </BottomSection>
        </Grid>
      </Wrapper>
    </Spin>
  );
};

export default VipStatusCard;
